import { AutogenModelDatafusionMapError, AutogenRowDatafusionMapError } from "./autogen/AutogenModelDatafusionMapError";

export class ModelDatafusionMapError extends AutogenModelDatafusionMapError<RowDatafusionMapError> {
	constructor() {
		super(RowDatafusionMapError);
	}
}

export class RowDatafusionMapError extends AutogenRowDatafusionMapError {
}